import { createContext, useContext } from 'react';

// Owned by GameShell so the results section and word-selection regions share
// the celebration barrier and an explicit, repeatable Lella request.
export const GameResultsPresentationContext = createContext({
  celebrationPending: false,
  boardPresentationReady: true,
  coachmarkVersion: 0,
  requestCoachmark: () => {},
});

export const useGameResultsPresentation = () => useContext(GameResultsPresentationContext);
